'use client'

import PreferredSourceButton from './PreferredSourceButton'
import { track } from '@/utils/analytics'

export default function FooterPreferredSource() {
  return (
    <PreferredSourceButton
      compact
      onClick={() =>
        track('preferred_source_badge_click', {
          cta_surface: 'footer',
          cta_position: 'bottom',
          page_type: 'sitewide_footer',
          destination:
            'https://www.google.com/preferences/source?q=microplasticsapp.com',
          external_completion_required: true,
        })
      }
    />
  )
}
